import { observable } from "mobx";
import { GET } from "Common/api";

class SettingStore {
  @observable settings = [];

  async init() {
    if (this.settings.length === 0) {
      const res = await GET("v1/adminsettings/");
      this.settings = res.settings;
    }
  }

  getSettingValue(name) {
    const row = this.settings?.find((s) => s.settingName === name);
    return row?.settingValue;
  }

  isBt() {
    return this.getSettingValue("bt") === "1";
  }

  viewLimitNr() {
    return (
      parseInt(this.getSettingValue("noofcoursesinmycoursespanel"), 10) || 3
    );
  }
}

export default new SettingStore();
